import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
const LessonVideo = () => {
    const { videoId } = useParams();

    return (
        <>
            {/* <MenuButtons /> */}
            <div className="centerlessons">
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="Lesson Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="lessonVideoMargin"
                />
            </div>
            <Link to="/lessons" className="centerTheMenuButtons" style={{ textDecoration: "none", color: "black" }}>
                <div className="globalButton" style={{ backgroundColor: "#6a9e8d", width: "30%", padding: "10px" }}>
                    <span className="mr-2">&#8592;</span> Back to Videos
                </div>
            </Link>
        </>
    )
}

export default LessonVideo